import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'elapsedTime',
    standalone: false
})
export class ElapsedTimePipe implements PipeTransform {
  transform(timestamp: number): string {
    var inputDate = new Date(timestamp);

    if(!inputDate) {
        return;
    }
    let currentTime = new Date();
    let totalTimeInSeconds = Math.floor( (currentTime.getTime() - inputDate.getTime())/1000 );
    if(totalTimeInSeconds < 10) {
        return  'just now';
    }else if( totalTimeInSeconds >=10 && totalTimeInSeconds < 60){
        return  `${Math.floor(totalTimeInSeconds)} secs ago`;
    }else if( (totalTimeInSeconds/60) <  60 ){
        return  Math.floor(totalTimeInSeconds/60) + (Math.floor(totalTimeInSeconds/60) ==1 ? ' min ago' : ' mins ago' );
    }else if( (totalTimeInSeconds/3600) <  24 ){
        return  Math.floor(totalTimeInSeconds/3600) + (Math.floor(totalTimeInSeconds/3600) ==1 ? ' hour ago' : ' hours ago' );
    }else if( (totalTimeInSeconds/(3600*24)) <  30 ){
        return  Math.floor(totalTimeInSeconds/(3600*24)) + (Math.floor(totalTimeInSeconds/(3600*24)) ==1 ? ' day ago' : ' days ago' );
    }else{
        return  Math.floor(totalTimeInSeconds/(3600*24*30)) + (Math.floor(totalTimeInSeconds/(3600*24*30)) ==1 ? ' month ago' : ' months ago' );
    }
  }
}